// Copyright Abridged, Inc. 2023,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - MiniAppRegistrationExcluding_sk-classifier-status-actions-publicKey-privateKey-id-classifier-classifierGroup-createdTime_
 * (tsType: Omit<MiniAppRegistration, 'sk' | 'classifier' | 'status' |
'actions' | 'publicKey' | 'privateKey' | 'id' | 'classifier' |
'classifierGroup' | 'createdTime'>, schemaOptions: { exclude: [ 'sk',
'classifier', 'status', 'actions', 'publicKey', 'privateKey', 'id',
'classifier', 'classifierGroup', 'createdTime' ] })
 */
@model({
  name: 'MiniAppRegistrationExcluding_sk-classifier-status-actions-publicKey-privateKey-id-classifier-classifierGroup-createdTime_',
})
export class MiniAppRegistrationExcludingSkClassifierStatusActionsPublicKeyPrivateKeyIdClassifierClassifierGroupCreatedTime {
  constructor(
    data?: Partial<MiniAppRegistrationExcludingSkClassifierStatusActionsPublicKeyPrivateKeyIdClassifierClassifierGroupCreatedTime>,
  ) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  pk?: string;

  /**
   * Name of the app.
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
      description: 'Name of the app.',
    },
  })
  name: string;

  /**
   * Url of icon for the app
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Url of icon for the app',
    },
  })
  icon?: string;

  /**
   * Description of App for which this is requested
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
      description: 'Description of App for which this is requested',
    },
  })
  description: string;

  /**
   * Feedback from user
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Feedback from user',
    },
  })
  feedback?: string;

  /**
   * Action url
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Action url',
    },
  })
  url?: string;

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
        description:
          'String of Array to get the platforms this app is available.',
      },
    },
  })
  platforms?: string[];

  /**
   * metadata
   */
  @property({
    jsonSchema: {
      type: 'object',
      description: 'metadata',
    },
  })
  metadata?: {};
}

export interface MiniAppRegistrationExcludingSkClassifierStatusActionsPublicKeyPrivateKeyIdClassifierClassifierGroupCreatedTimeRelations {
  // describe navigational properties here
}

export type MiniAppRegistrationExcludingSkClassifierStatusActionsPublicKeyPrivateKeyIdClassifierClassifierGroupCreatedTimeWithRelations =
  MiniAppRegistrationExcludingSkClassifierStatusActionsPublicKeyPrivateKeyIdClassifierClassifierGroupCreatedTime &
    MiniAppRegistrationExcludingSkClassifierStatusActionsPublicKeyPrivateKeyIdClassifierClassifierGroupCreatedTimeRelations;
